import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

import "../../GlobalServices/Destinations/Destinations.css"

const YourSafetyAndWellBeing = () => {
  return (
    <div>
        <div className="Destination YOUR-Safety">
    <div className="container ServiceOffering">
        <div className="row">
          <div className="col-md-12 ">
            <div className="d-flex justify-content-center align-items-center flex-column">
              <h1 className="headings text-center"> 
                <span>Our Priority </span> : Your Safety & Wellbeing
              </h1>
           
            </div>
          </div>
        </div>
        <div className="row px-lg-5 px-md-0 px-4 mlTab">
        <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3 d-flex justify-content-center">
          <div className="DT-box1 ">
            <div className="row">
              <div className="col-md-12">
                <div className="Destinations-img d-flex justify-content-center">
                <LazyLoadImage
            effect="blur"
 src='https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/YourSafetyIcon-1.png' alt="" className="img-fluid" loading="lazy"  />
                </div>
              
              </div>
              <div className="col-md-12 p-4">
                <h5 className="headings text-center desti-head-global">
                24x7 ASSISTANCE
                </h5>
                <p className="mt-3 text-center desti-para grotesk-headings">
                We offer round-the-clock assistance for your travels. During your trip, if you face any issues or need help, our support team is always available to assist you. </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
          <div className="DT-box1 DT-box2">
            <div className="row">
              <div className="col-md-12">
              <div className="Destinations-img d-flex justify-content-center">
                <LazyLoadImage
            effect="blur"
 src='https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/YourSafetyIcon-2.png' alt="" className="img-fluid" loading="lazy"  />
                </div>
              </div>
              <div className="col-md-12 p-4">
                <h5 className="headings text-center desti-head-global">
                TRAVEL INSURANCE              
                 </h5>
                <p className="mt-3 text-center desti-para grotesk-headings">
                We offer various travel insurance options that you can pick from. Your safety comes first to us.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
          <div className="DT-box1 DT-box3 ">
            <div className="row">
              <div className="col-md-12">
                <div className="Destinations-img d-flex justify-content-center">
                <LazyLoadImage
            effect="blur"
 src='https://blueberrydatastorage.blob.core.windows.net/bbt/icons/TourismIcons/YourSafetyIcon-3.png' alt="" className="img-fluid"  loading="lazy" />
                </div>
              </div>
              <div className="col-md-12 p-4">
                <h5 className="headings text-center desti-head-global">DUTY OF CARE</h5>
                <p className="mt-3 text-center desti-para grotesk-headings">
                We have a systematic plan to ensure that the travel risks are minimal. In case of an emergency, we will send alerts to you.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
     
    </div>
    </div>
  )
}

export default YourSafetyAndWellBeing
